import './article_2.scss';
import BI from './assets/bi.png';
import img_0 from './assets/0.png';

export default function Article_2() {

    window.scrollTo(0, 0);

    return (
        <div className="article_2">
            <img src={BI} alt="header" />
            <div className="content">
                <h2>
                    С граждан спросится
                </h2>
                <h5>
                    Большинство граждан смогут покупать на бирже наиболее рискованные инструменты, а также проводить сделки с «плечом» (на заемные средства) только после тестирования у брокера. Закон об этом («о категоризации инвесторов») публикует «РГ».
                </h5>
                <img src={img_0} alt="img_0" />
                <p>
                    Теперь Банк России должен определить круг иностранных акций и требования к рейтингу облигаций, доступных неквалифицированным инвесторам без тестирования. Правила тестирования будут закреплены в базовом стандарте, он готовится НАУФОР и НФА (СРО на финрынке) и Службой по защите прав инвесторов Банка России.
                </p>
                <p>
                    Как рассказал «РГ» глава НАУФОР Алексей Тимофеев, обсуждаются тесты по семи группам инструментов и сделок: структурным облигациям, маржинальной торговле, сделкам РЕПО, производным финансовым инструментам, закрытым ПИФам, облигациям без рейтингов, а также по иным инструментам, требующим тестирования, но не вошедшим в первые шесть групп (в этом тесте вопросы посвящены низколиквидным бумагам). Вероятно, появится восьмая группа — иностранные ценные бумаги. Предполагается, что каждый тест будет состоять из семи базовых вопросов (но брокеры вправе добавить к ним свои), в которых первые три посвящены опыту работы на финрынке и с конкретным инструментом, а еще четыре — специфике инструмента или сделки. Стандарты определят, какая комбинация ответов позволит считать тест сданным. «Вопросы будут публичны, каждый сможет подготовиться, уверен, что многие брокеры будут помогать клиентам подготовиться к сдаче теста, — говорит Тимофеев. — Это наилучший способ донести до клиента риски, с которыми для него сопряжены те или иные инструменты, и убедиться в понимании их специфики».
                </p>
                <h5>
                    Те, кто не прошел тест, все равно смогут совершить сделку, но только на сумму до 100 тыс. руб. (или на сумму одного лота, если он стоит дороже).
                </h5>
                <p>
                    Те, у кого мало опыта, все равно смогут совершить сделку, но только в пределах ста тысяч рублей
                </p>
                <p>
                    Новый закон не ограничивает граждан в покупке российских акций, включенных в котировальные списки, ОФЗ, облигаций российских компаний с хорошим кредитным рейтингом, биржевых, открытых и интервальных ПИФов, а также иностранных ценных бумаг, включенных в индексы, перечень которых утвердит Банк России. Ключевые изменения вступят в силу только в апреле 2022 года.
                </p>
            </div>
        </div>
    )
}